<template>
    <div class="soluBox">
      <v-header></v-header>
      <div class="emptyheader"></div>
      <v-Gotop></v-Gotop>
      <div class="soluMain">
          <div class="soluBanner">
              <p class="title">物流解决方案</p>
              <p class="content">针对各行业务特性，打造个性化行业解决方案，为用户提供一站式 的产品与服务。包括C端寄件、电商平台、综合类快递平台、对总 业务和逆向物流等行业领域。</p>
          </div>
          <div class="modelBox">
              <h2 style="padding:30px 0; text-align:center">专业物流模块即刻接入</h2>
              <div class="rowList" v-for="(rowItem,index) in soluList" :key="index">
                 <div class="rowItem" v-for="(item,i) in rowItem" :key="i">
                     <div class="left">
                         <img :src="item.solutionIcon" alt=""/>
                     </div>
                     <div class="right">
                        <p class="title">{{item.solutionName}}</p>
                        <p class="decstion">{{item.solutionIntro}}</p>
                        <div class="tolinkMore" v-if="item.isLast">{{item.tolinkMore}}</div>
                        <ul class="list" v-else>
                            <li class="listItem" @click="toDetails(lastItem)" v-for='(lastItem,lastindex) in item.solutionApiList' :key="lastindex">{{lastItem.apiName ? lastItem.apiName : lastItem.title }}</li>
                        </ul>
                     </div>
                 </div>
              </div>   
          </div>
      </div>
      <v-footer></v-footer>
    </div>
</template>
<script>
import Solu4 from '@/assets/images/solu-4.png';
import Solution from '@/apis/solution.js';
import Header from "../layout/components/header";
import vGotop from "../layout/components/goTop";
import Footer from "../layout/components/footer";
export default {
    name:'Solution',
    data(){
        return{
         soluList:[],
        }
    },
    created(){
        this.getdata();
    },
    methods:{
        /** 跳转详情 */
        toDetails(query) {
            if(query.apiCode){
                let newpage = this.$router.resolve({
                    path: "/api/apiDoc",
                    query:{apiCode:query.apiCode}
                });
                window.open(newpage.href, "_blank");
            }else{
                window.open(query.url,"_blank");
            }
        },
        getdata(){
            Solution.getSolution().then(res=>{
               const data = res.data;
               data.push({
                 solutionIcon:Solu4,
                 solutionName:'总对总业务和逆向物流',
                 solutionIntro:'品牌连锁电商及自营电商对结算及逆向有需求的物流应用解决方案使用接口:',
                 isLast:true,
                 tolinkMore:'请联系韵达市场部获取',
               })
               for(var i=0;i<data.length;i+=2){
                    this.soluList.push(data.slice(i,i+2));
               }
               const lastIndex = this.soluList.length - 1;
               if(this.soluList[lastIndex].length == 1){
                   this.soluList[lastIndex].push({
                        solutionIcon:'',
                        solutionName:'',
                        solutionIntro:'',
                        solutionApiList:[],
                   })
               }
              console.log(this.soluList)
            })
        },
    },
    components: {
        "v-header": Header,
        "v-Gotop":vGotop,
        "v-footer": Footer
    }
}
</script>
<style lang="less" scoped>
.soluMain{
    width: 100%;
    .soluBanner{
        width:100%;
        height: 480px;
        background: url(../assets/images/soluBg.png) center no-repeat;
        background-size: cover;
        position: relative;
        .title{
            position: absolute;
            top:160px;
            color: #333333;
            font-weight: bold;
            font-size: 30px;
            @media screen and(max-width: 1280px){
                left: 80px; 
            }
            @media screen and(min-width: 1280px) {
                left: 80px;   
            }
            @media screen and(min-width: 1366px) {
                left: 120px;  
            }
            @media screen and(min-width: 1440px) {
                left: 160px;
            }
            @media screen and(min-width: 1680px) {
                left:280px;
            }
            @media screen and(min-width: 1920px) {
                left:400px;
            }
        }
        .content{
            position: absolute;
            top:208px;
            color: #333333;
            width: 406px;
            height: 50px;
            font-size: 16px;
            @media screen and(max-width: 1280px){
                left: 80px; 
            }
            @media screen and(min-width: 1280px) {
                left: 80px;   
            }
            @media screen and(min-width: 1366px) {
                left: 120px;  
            }
            @media screen and(min-width: 1440px) {
                left: 160px;
            }
            @media screen and(min-width: 1680px) {
                left:280px;
            }
            @media screen and(min-width: 1920px) {
                left:400px;
            }
        }
    }
    .modelBox{
      .rowList{
          display: flex;
          justify-content: center;
          .rowItem{
              width: 500px;
              display: flex;
              justify-content: space-between;
              padding:20px 0 40px 0;
              border-bottom: 1px dashed #A5A5A5;
              .left{
                  width: 100px;
                  height: 100px;
                  margin-left: 50px;
                  img{
                      width: 100%;
                  }
              }
              .right{
                margin:0 50px;
                width: 294px;
                box-sizing: border-box;
                .title{
                    color: #000000;
                    font-weight: bold;
                }
                .decstion{
                    color: #A5A5A5;
                    font-size: 12px;
                    padding-top: 10px;
                    padding-bottom: 20px;
                }
                .list{
                    color:#066BF2;
                    .listItem{
                        position: relative;
                        line-height: 28px;
                        cursor: pointer;
                        &:before{
                            content:'';
                            position: absolute;
                            top:8px;
                            left: -20px;
                            background: #F4314D;
                            width: 10px;
                            height: 10px;
                            border-radius: 50%;
                        }   
                        &:after{
                            content:'';
                            position: absolute;
                            top: 10px;
                            left: -18px;
                            background: #fff;
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                        }                      
                    }
                }
                .tolinkMore{
                    height: 40px;
                    line-height: 40px;
                    color: #066bf2;
                    text-align: left;
                    width: 200px;

                }
              }
              &:last-child {
                border-left: 1px dashed #A5A5A5; 
              }
          }
      }  
    }
}
</style>